import design from 'design';
import hooks from 'hooks';
import './Loading.view.scss';

export default () => {
    const component = hooks.useComponent({
        name: 'LoadingView'
    });

    return (
        <div className={component.classNames(component.name, 'full-center')}>
            <design.components.common.ProgressSpinner/>
        </div>
    )
};
